import React from 'react';
import { Route } from 'react-router-dom';
import Routes from 'constants/Routes';

import QuoteInfo from './pages/add';
import QuotePlans from './pages/plans';
import PaymentPage from './pages/payment';
import Certificate from './pages/issue';

export default function AioRoutes() {
  return (
    <>
      <Route exact path={Routes.AIONEWQUOTATIONINFO} component={QuoteInfo} />
      <Route path={Routes.AIONEWQUOTATIONPLANS} component={QuotePlans} />
      <Route path={Routes.AIOPAYMENTS} component={PaymentPage} />
      <Route path={Routes.AIOISSUE} component={Certificate}/>
    </>
  );
}
